<template>
  <div>
    <div class="d-flex">
      <CButton
        class="headerActions__button"
        v-c-tooltip="{ content: 'Approve', placement: 'top' }"
        @click.stop="aproveEvent"
        v-c-emit-root-event:approveOrReprove="{ status: 2, reasonText: 'reasonText' }"
      >
        <CIcon name="approvedFull" class="text-success" size="custom-size" :height="25" viewBox="0 0 32 32" />
      </CButton>
      <CButton class="headerActions__button" v-c-tooltip="{ content: 'Refuse', placement: 'top' }" @click.stop="refuseEvent">
        <CIcon name="refusedFull" class="text-danger" size="custom-size" :height="25" viewBox="0 0 32 32" />
      </CButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AproveRefuse',
  data() {
    return {}
  },
  methods: {
    aproveEvent() {
      this.$emit('aproved')
    },

    refuseEvent() {
      this.$emit('refused')
    },
  },
}
</script>

<style lang="scss" scope>
.list {
  max-height: 300px;
  overflow-x: scroll;
  &__item {
    color: var(--gray-700);

    &:hover {
      background: transparentize($primary, 0.75);
    }
  }

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: var(--gray-500);
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #f1f1f1;
  }
}
</style>
